(function () {
  var SELECTOR = '[data-seal-ocean-impact-counter], [data-seal-ocean-cleanup-banner]';
  var DIGITS = '0123456789';
  var REEL_REPEAT_COUNT = 9;
  var LIVE_STORAGE_PREFIX = 'seal:ocean-impact-counter:';
  var LIVE_STORAGE_TTL = 6 * 60 * 60 * 1000;
  var INITIAL_COUNT_DURATION = 3000;
  var INITIAL_COUNT_FRAME_INTERVAL = 45;
  var LIVE_COUNT_FRAME_INTERVAL = 55;
  var LIVE_COUNT_STEP_DURATION = 130;

  function getLocale() {
    var lang = document.documentElement.lang || 'de-DE';
    return lang.replace('_', '-');
  }

  function formatNumber(value) {
    var rounded = Math.round(value);

    try {
      return new Intl.NumberFormat(getLocale(), { maximumFractionDigits: 0 }).format(rounded);
    } catch (error) {
      return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function parseDataNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function parseDataBoolean(value, fallback) {
    if (value === 'true') return true;
    if (value === 'false') return false;

    return fallback;
  }

  function parseCounterValue(value) {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value === 'string') {
      var trimmed = value.trim();
      if (!trimmed) return null;

      var numeric = Number(trimmed.replace(/[.,\s]/g, ''));
      return Number.isFinite(numeric) ? numeric : null;
    }

    return null;
  }

  function parseCounterPayload(data) {
    var directValue = parseCounterValue(data);
    if (directValue != null) return directValue;

    if (typeof data === 'string') {
      var trimmed = data.trim();
      if (trimmed[0] === '{' || trimmed[0] === '[') {
        try {
          return parseCounterPayload(JSON.parse(trimmed));
        } catch (error) {
          return null;
        }
      }
    }

    if (data && data.total_m2 != null) return parseCounterValue(data.total_m2);
    if (data && data.total != null) return parseCounterValue(data.total);
    if (data && data.value != null) return parseCounterValue(data.value);
    return null;
  }

  function randomInt(min, max) {
    var safeMin = Math.ceil(Math.min(min, max));
    var safeMax = Math.floor(Math.max(min, max));

    return Math.floor(Math.random() * (safeMax - safeMin + 1)) + safeMin;
  }

  function storageKeyFor(endpoint) {
    return LIVE_STORAGE_PREFIX + String(endpoint || 'default').replace(/[^a-z0-9_-]+/gi, '-').slice(0, 120);
  }

  function createDigit() {
    var digit = document.createElement('span');
    var stack = document.createElement('span');

    digit.className = 'seal-ocean-cleanup-banner__digit';
    digit.setAttribute('aria-hidden', 'true');
    stack.className = 'seal-ocean-cleanup-banner__digit-stack';

    stack.textContent = Array(REEL_REPEAT_COUNT).fill(DIGITS.split('').join('\n')).join('\n');

    digit.appendChild(stack);

    return digit;
  }

  function initCounter(root) {
    if (!root || root.dataset.sealOceanImpactCounterInitialized === 'true') return;

    var counterEl = root.querySelector('[data-seal-ocean-impact-counter-value], [data-seal-ocean-cleanup-banner-counter]');
    if (!counterEl) return;

    root.dataset.sealOceanImpactCounterInitialized = 'true';

    var endpoint = root.dataset.endpoint || 'https://wmi-group.at/api/trash-removed/';
    var fallbackValue = parseDataNumber(root.dataset.fallbackValue || counterEl.dataset.fallbackValue, 763022);
    var minValidValue = parseDataNumber(root.dataset.minValidValue, 100);
    var minDigits = Math.max(1, parseInt(root.dataset.minDigits || '7', 10));
    var liveCounterEnabled = parseDataBoolean(root.dataset.liveCounterEnabled, true);
    var liveMinInterval = Math.max(1000, parseDataNumber(root.dataset.liveMinInterval, 5000));
    var liveMaxInterval = Math.max(liveMinInterval, parseDataNumber(root.dataset.liveMaxInterval, 30000));
    var liveMinIncrement = Math.max(1, parseDataNumber(root.dataset.liveMinIncrement, 11));
    var liveMaxIncrement = Math.max(liveMinIncrement, parseDataNumber(root.dataset.liveMaxIncrement, 198));
    var counterAriaTemplate = root.dataset.counterAriaTemplate || '';
    var liveStorageKey = storageKeyFor(endpoint);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentValue = 0;
    var digitCount = Math.max(minDigits, String(Math.round(fallbackValue)).length);
    var animationTimeoutId = null;
    var initialCountFrameId = null;
    var livePulseTimeoutId = null;
    var hasStarted = false;
    var currentPositions = [];
    var digitEls = [];
    var digitStacks = [];
    var digitHeight = 0;

    function numberToDigits(value) {
      return String(Math.max(0, Math.round(value))).padStart(digitCount, '0');
    }

    function ensureDigitCount(value) {
      var nextCount = Math.max(minDigits, String(Math.max(0, Math.round(value))).length);

      if (nextCount === digitCount && counterEl.children.length === digitCount) return;

      digitCount = nextCount;
      counterEl.textContent = '';

      for (var index = 0; index < digitCount; index += 1) {
        counterEl.appendChild(createDigit());
      }

      refreshDigitMetrics();
    }

    function refreshDigitMetrics() {
      digitEls = Array.prototype.slice.call(counterEl.querySelectorAll('.seal-ocean-cleanup-banner__digit'));
      digitStacks = digitEls.map(function (digitEl) {
        return digitEl.firstElementChild;
      });
      digitHeight = digitEls[0] ? digitEls[0].getBoundingClientRect().height : 0;
    }

    function moveStack(stack, height, position, instant, duration, delay) {
      if (!stack || !height) return;

      stack.style.transition = instant || reduceMotion ? 'none' : 'transform ' + duration + 'ms cubic-bezier(0.16, 1, 0.3, 1) ' + delay + 'ms';
      stack.style.transform = 'translate3d(0, -' + position * height + 'px, 0)';
    }

    function setDigits(value, instant, updateAria) {
      ensureDigitCount(value);

      var digits = numberToDigits(value);

      if (!digitHeight || digitEls.length !== digitCount) {
        refreshDigitMetrics();
      }

      digits.split('').forEach(function (number, index) {
        var stack = digitStacks[index];
        var position = Number(number);

        if (!stack || !digitHeight) return;

        currentPositions[index] = position;
        moveStack(stack, digitHeight, position, true, 0, 0);
      });

      if (updateAria !== false && counterAriaTemplate) {
        counterEl.setAttribute('aria-label', counterAriaTemplate.replace('__value__', formatNumber(value)));
      }
    }

    function normalizeDigitPosition(index) {
      var stack = digitStacks[index];
      var currentPosition = currentPositions[index] || 0;
      var normalizedPosition = ((currentPosition % 10) + 10) % 10;

      if (!stack || currentPosition < 70) return;

      currentPositions[index] = normalizedPosition;
      moveStack(stack, digitHeight, normalizedPosition, true, 0, 0);
    }

    function setDigitsRolling(value, duration, updateAria) {
      ensureDigitCount(value);

      var digits = numberToDigits(value);

      if (!digitHeight || digitEls.length !== digitCount) {
        refreshDigitMetrics();
      }

      digits.split('').forEach(function (number, index) {
        var stack = digitStacks[index];
        var currentPosition = currentPositions[index] || 0;
        var currentDigit = ((currentPosition % 10) + 10) % 10;
        var targetDigit = Number(number);
        var delta = (targetDigit - currentDigit + 10) % 10;

        if (!stack || !digitHeight || delta === 0) return;

        normalizeDigitPosition(index);
        currentPosition = currentPositions[index] || 0;

        var nextPosition = currentPosition + delta;

        currentPositions[index] = nextPosition;
        moveStack(stack, digitHeight, nextPosition, false, duration, 0);
      });

      if (updateAria !== false && counterAriaTemplate) {
        counterEl.setAttribute('aria-label', counterAriaTemplate.replace('__value__', formatNumber(value)));
      }
    }

    function readStoredLiveValue(floorValue) {
      try {
        if (!window.localStorage) return floorValue;

        var raw = window.localStorage.getItem(liveStorageKey);
        if (!raw) return floorValue;

        var data = JSON.parse(raw);
        var storedValue = Number(data && data.value);
        var updatedAt = Number(data && data.updatedAt);

        if (!storedValue || Number.isNaN(storedValue) || !updatedAt || Date.now() - updatedAt > LIVE_STORAGE_TTL) {
          return floorValue;
        }

        return Math.max(floorValue, storedValue);
      } catch (error) {
        return floorValue;
      }
    }

    function storeLiveValue(value) {
      try {
        if (!window.localStorage) return;

        window.localStorage.setItem(
          liveStorageKey,
          JSON.stringify({
            value: Math.max(0, Math.round(value)),
            updatedAt: Date.now()
          })
        );
      } catch (error) {
        // Storage can be unavailable in private contexts; the counter still works without persistence.
      }
    }

    function clearLivePulse() {
      if (livePulseTimeoutId) {
        window.clearTimeout(livePulseTimeoutId);
        livePulseTimeoutId = null;
      }
    }

    function clearInitialCount() {
      if (initialCountFrameId) {
        window.cancelAnimationFrame(initialCountFrameId);
        initialCountFrameId = null;
      }
    }

    function scheduleLivePulse() {
      if (!liveCounterEnabled || !hasStarted) return;

      clearLivePulse();

      livePulseTimeoutId = window.setTimeout(function () {
        var storedValue = readStoredLiveValue(currentValue);
        var nextValue = Math.max(currentValue, storedValue) + randomInt(liveMinIncrement, liveMaxIncrement);

        storeLiveValue(nextValue);
        animateTo(nextValue, scheduleLivePulse, { spinAllDigits: false });
      }, randomInt(liveMinInterval, liveMaxInterval));
    }

    function animateLiveCount(target, onComplete, startValue) {
      var valueDelta = Math.max(0, Math.round(target - startValue));
      var startTime = null;
      var lastFrameTime = 0;
      var lastDisplayValue = startValue;
      var duration = Math.min(1200, Math.max(760, valueDelta * 5));

      function step(timestamp) {
        if (!startTime) startTime = timestamp;

        var progress = Math.min((timestamp - startTime) / duration, 1);

        if (progress < 1 && timestamp - lastFrameTime < LIVE_COUNT_FRAME_INTERVAL) {
          initialCountFrameId = window.requestAnimationFrame(step);
          return;
        }

        lastFrameTime = timestamp;

        var displayValue = Math.min(target, Math.floor(startValue + valueDelta * progress));

        if (displayValue > lastDisplayValue) {
          currentValue = displayValue;
          setDigitsRolling(displayValue, LIVE_COUNT_STEP_DURATION, false);
          lastDisplayValue = displayValue;
        }

        if (progress < 1) {
          initialCountFrameId = window.requestAnimationFrame(step);
          return;
        }

        initialCountFrameId = null;
        currentValue = target;
        setDigits(currentValue, true);
        if (onComplete) onComplete();
      }

      initialCountFrameId = window.requestAnimationFrame(step);
    }

    function animateTo(target, onComplete, options) {
      if (typeof target !== 'number' || Number.isNaN(target)) return;

      options = options || {};
      target = Math.max(0, target);
      ensureDigitCount(target);
      clearInitialCount();

      if (animationTimeoutId) {
        window.clearTimeout(animationTimeoutId);
      }

      if (reduceMotion) {
        currentValue = target;
        setDigits(currentValue, true);
        if (onComplete) onComplete();
        return;
      }

      var startValue = currentValue || 0;

      if (target === startValue) {
        setDigits(target, true);
        if (onComplete) onComplete();
        return;
      }

      setDigits(startValue, true);

      var direction = target >= startValue ? 1 : -1;

      if (options.spinAllDigits === false && direction > 0) {
        animateLiveCount(target, onComplete, startValue);
        return;
      }

      var targetDigits = numberToDigits(target);
      var spinAllDigits = options.spinAllDigits !== false;
      var maxDuration = 0;

      window.requestAnimationFrame(function () {
        if (!digitHeight || digitEls.length !== digitCount) {
          refreshDigitMetrics();
        }

        targetDigits.split('').forEach(function (number, index) {
          var stack = digitStacks[index];
          var targetDigit = Number(number);
          var currentPosition = currentPositions[index] || 0;
          var currentDigit = ((currentPosition % 10) + 10) % 10;
          var delta = (targetDigit - currentDigit + 10) % 10;
          var spinCount = spinAllDigits ? 2 + Math.min(4, digitCount - index) : 0;
          var delay = index * 65;
          var duration = 1180 + index * 45;
          var nextPosition = direction > 0 ? currentPosition + delta : targetDigit;

          nextPosition += spinCount * 10;
          maxDuration = Math.max(maxDuration, delay + duration);
          currentPositions[index] = nextPosition;
          moveStack(stack, digitHeight, nextPosition, direction < 0, duration, delay);
        });

        if (maxDuration === 0) {
          currentValue = target;
          setDigits(currentValue, true);
          if (onComplete) onComplete();
          return;
        }

        animationTimeoutId = window.setTimeout(function () {
          currentValue = target;
          setDigits(currentValue, true);
          if (onComplete) onComplete();
        }, maxDuration + 80);
      });
    }

    function animateInitialCount(target, onComplete) {
      if (typeof target !== 'number' || Number.isNaN(target)) return;

      target = Math.max(1, Math.round(target));
      ensureDigitCount(target);
      clearInitialCount();

      if (animationTimeoutId) {
        window.clearTimeout(animationTimeoutId);
      }

      if (reduceMotion) {
        currentValue = target;
        setDigits(currentValue, true);
        if (onComplete) onComplete();
        return;
      }

      var startValue = 1;
      var startTime = null;
      var lastDisplayValue = 0;
      var lastFrameTime = 0;

      setDigits(startValue, true, false);

      function step(timestamp) {
        if (!startTime) startTime = timestamp;

        var progress = Math.min((timestamp - startTime) / INITIAL_COUNT_DURATION, 1);
        if (progress < 1 && timestamp - lastFrameTime < INITIAL_COUNT_FRAME_INTERVAL) {
          initialCountFrameId = window.requestAnimationFrame(step);
          return;
        }

        lastFrameTime = timestamp;

        var displayValue = Math.max(startValue, Math.floor(startValue + (target - startValue) * progress));

        if (displayValue !== lastDisplayValue) {
          currentValue = displayValue;
          setDigits(displayValue, true, false);
          lastDisplayValue = displayValue;
        }

        if (progress < 1) {
          initialCountFrameId = window.requestAnimationFrame(step);
          return;
        }

        initialCountFrameId = null;
        currentValue = target;
        setDigits(currentValue, true);
        if (onComplete) onComplete();
      }

      initialCountFrameId = window.requestAnimationFrame(step);
    }

    function startFromValue(baseValue) {
      var displayValue = readStoredLiveValue(baseValue);

      animateInitialCount(displayValue, function () {
        storeLiveValue(displayValue);
        scheduleLivePulse();
      });
    }

    function fetchInitialValue() {
      if (!window.fetch) {
        startFromValue(fallbackValue);
        return;
      }

      window
        .fetch(endpoint, { cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error');
          return response.text();
        })
        .then(function (data) {
          var total = parseCounterPayload(data);

          if (total == null || Number.isNaN(total) || total <= minValidValue) {
            startFromValue(fallbackValue);
            return;
          }

          startFromValue(total);
        })
        .catch(function () {
          startFromValue(fallbackValue);
        });
    }

    function startCounter() {
      if (hasStarted) return;

      hasStarted = true;
      fetchInitialValue();
    }

    ensureDigitCount(fallbackValue);
    setDigits(0, true);

    window.addEventListener('resize', function () {
      refreshDigitMetrics();
      setDigits(currentValue, true);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(root)) {
        clearInitialCount();
        clearLivePulse();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              startCounter();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(root);
    } else {
      startCounter();
    }
  }

  function initAllCounters() {
    document.querySelectorAll(SELECTOR).forEach(initCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCounters, { once: true });
  } else {
    initAllCounters();
  }

  document.addEventListener('shopify:section:load', initAllCounters);
})();
